@if(this.promotions?.body){
  <div class="banner">
    <h6>{{ titoloPromo }}</h6>
  </div>
}
